import { Schedule } from '@/features/accounts/types';
import FormattedAppointment from '@/shared/i18n/components/FormattedAppointment';

interface Props {
  schedule: Schedule | null;
}

export default function CurrentAppointmentCell({ schedule }: Props) {
  if (!schedule) return null;
  if (!schedule.current_consular_at) {
    return <span className="text-slate-400">—</span>;
  }
  return (
    <div className="flex flex-col">
      <FormattedAppointment at={schedule.current_consular_at} />
      {schedule.current_consular_facility && (
        <span className="text-xs text-slate-400">@ {schedule.current_consular_facility.name}</span>
      )}
    </div>
  );
}
